<page-grid [gridConfig]="gridConfig()" (gridClickColumn)="handleColumnClick($event)"/>
